export default __webpack_public_path__ + "img/dXqmyKuY.4216ff23.svg";